import React, { Component } from 'react';
import { connect } from 'react-redux';
import AuthView from 'components/AuthView';
import { SORT_ORDER } from 'components/ListView/constants';
import { getDefaultPageSize } from 'components/Pagination/PageSizeSelect';
import {
    fetchScooterList,
    updateDocumentTitle,
    clearSingleScooter,
    fetchOperationUsers,
} from 'actions';
import FilterBar, {
    FILTER_SERVICE,
    FILTER_RENTAL_STATE,
    FILTER_BATTERY,
    FILTER_TRACKER_SOC,
    FILTER_MAIN_TYPE,
    FILTER_SUB_TYPE,
    FILTER_MODEL,
    FILTER_CITY,
    FILTER_SCOOTER_TICKET,
    FILTER_VIP_SCOOTER,
} from './FilterBar';
import List from './List';
import { importFilterShortcutPayload } from 'hooks/useFilterShortcut';

import './scooter-list.scss';

export const DEFAULT_SCOOTER_LIST_PAYLOAD = {
    plate: undefined,
    filter: {
        [FILTER_SERVICE]: undefined,
        [FILTER_RENTAL_STATE]: undefined,
        [FILTER_BATTERY]: undefined,
        [FILTER_TRACKER_SOC]: undefined,
        [FILTER_MAIN_TYPE]: undefined,
        [FILTER_SUB_TYPE]: undefined,
        [FILTER_MODEL]: undefined,
        [FILTER_CITY]: undefined,
        [FILTER_SCOOTER_TICKET]: undefined,
        [FILTER_VIP_SCOOTER]: undefined,
    },
    sort: undefined,
    page: 1,
    size: getDefaultPageSize().value,
};

class ScooterList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedIdList: [],
            queryPayload: {
                ...DEFAULT_SCOOTER_LIST_PAYLOAD,
            },
        };
        this.pauseRefresh = false;

    }

    componentDidMount() {
        const { dispatch, location, history } = this.props;
        const { pathname, state: locationState } = location;
        dispatch(fetchOperationUsers());
        dispatch(updateDocumentTitle(`routes.${ pathname }`));

        // from other route
        importFilterShortcutPayload(
            history,
            locationState,
            this
        );
    }
    componentDidUpdate(prevProps) {
        const { location: prevLocation, history } = prevProps;
        const { location } = this.props;
        const { state: locationState } = location;
        // keep filtering on same route
        if (locationState && prevLocation.state !== locationState) {
            importFilterShortcutPayload(
                history,
                locationState,
                this,
                this.fetchScooterList,
            );
        }
    }

    componentWillUnmount() {
        const { dispatch } = this.props;
        dispatch(clearSingleScooter());


    }

    handleSubmit = value => {
        this.setState((prevState) => ({
            selectedIdList: [],
            queryPayload: {
                ...prevState.queryPayload,
                filter: {},
                plate: value === '' ? undefined : value,
                page: 1,
                sort: undefined,
            }
        }), this.fetchScooterList);

    }

    handleReverseSort = (sort) => {
        let [field, order] = sort?.split(',') ?? [];
        if (field && order) {
            if (field === 'idle_time' || field === 'last_connection_date') {
                switch (order) {
                case SORT_ORDER.ASC:
                    order = SORT_ORDER.DESC;
                    break;
                case SORT_ORDER.DESC:
                    order = SORT_ORDER.ASC;
                    break;
                default:
                }
                sort = `${ field },${ order }`;
            }
        }
        return sort;
    };

    fetchScooterList = () => {
        const { dispatch } = this.props;
        const { queryPayload } = this.state;
        const { filter, ...params } = queryPayload;
        const { sort } = params;
        return dispatch(fetchScooterList({
            ...filter,
            ...params,
            sort: this.handleReverseSort(sort),
        }));
    }

    handleFilterOn = (type, value) => {
        const { queryPayload } = this.state;
        let { filter } = queryPayload;

        switch (type) {
        case FILTER_SERVICE:
        case FILTER_RENTAL_STATE:
        case FILTER_MODEL:
        case FILTER_CITY:
        case FILTER_MAIN_TYPE:
        case FILTER_SUB_TYPE:
        case FILTER_VIP_SCOOTER:
        case FILTER_SCOOTER_TICKET:
            filter = {
                ...filter,
                [type]: value.inputSelect,
            };
            break;
        case FILTER_BATTERY:
        case FILTER_TRACKER_SOC:
            filter[`${type}_from`] = value.from;
            filter[`${type}_to`] = value.to;
            break;
        default:
        };

        // rebind
        this.setState((prevState) => ({
            selectedIdList: [],
            queryPayload: {
                ...prevState.queryPayload,
                filter,
                page: 1,
            },
        }), this.fetchScooterList);

    };

    handleChange = type => value => {
        let { queryPayload } = this.state;
        queryPayload.page = 1;
        queryPayload[type] = value;

        this.setState({
            selectedIdList: [],
            queryPayload: {
                ...queryPayload,
            }
        }, this.fetchScooterList);
    }

    handleSelect = list => {
        this.setState({
            selectedIdList: list,
        });
    }

    render() {
        const { selectedIdList, queryPayload } = this.state;

        return (
            <AuthView className="scooter-list">
                <FilterBar
                    defaultSettings={ queryPayload }
                    onChange={ this.handleFilterOn }
                    onSubmit={ this.handleSubmit }
                />
                <List
                    pageSize={ queryPayload.size }
                    onFetch={ this.fetchScooterList }
                    onSelect={ this.handleSelect }
                    onChange={ this.handleChange }
                    selectedIdList={ selectedIdList }
                    defaultSorted={ queryPayload.sort }
                />
            </AuthView>
        );
    }
}

export default connect(state => ({
    i18n: state.i18n,
}))(ScooterList);
